import { wcfConfig } from "../utils";
import * as basket from "../eaiws/basket";
const getArticleDataOptions = new basket.GetArticleDataOptions();
getArticleDataOptions.noProperties = false;
getArticleDataOptions.fetchCatalogIcon = false;
getArticleDataOptions.fetchCatalogImage = true;
getArticleDataOptions.separateCurrencies = true;
export function getDefaultGetArticleDataOptions() {
    const tConfOptions = wcfConfig.articleConfigurationOptions;
    getArticleDataOptions.fetchPropValueImages = tConfOptions.fetchPropValueImages;
    getArticleDataOptions.highResPropValueIcons = tConfOptions.highResPropValueIcons;
    return (getArticleDataOptions);
}
